import SeoHead from '../../components/feature/SeoHead';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Desguace en Esplugues de Llobregat – Compra de Coches',
  description: 'Compramos coches en Esplugues de Llobregat al mejor precio. Siniestrados, averiados, sin ITV. Recogida gratuita y pago inmediato.',
  provider: {
    '@type': 'AutoDealer',
    name: 'Desguace Barcelona',
    telephone: '+34932932913',
    address: { '@type': 'PostalAddress', addressLocality: 'Esplugues de Llobregat', addressRegion: 'Cataluña', addressCountry: 'ES' },
  },
  areaServed: { '@type': 'City', name: 'Esplugues de Llobregat' },
  url: `${siteUrl}/desguace-esplugues`,
};

export default function DesguaceEspluguesPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Desguace en Esplugues de Llobregat | Mejor Precio | Recogida Gratis"
        description="Desguace en Esplugues de Llobregat. Compramos coches siniestrados, averiados o sin ITV al mejor precio. Recogida gratuita en Esplugues y pago inmediato."
        keywords="desguace Esplugues, vender coche Esplugues Llobregat, compra coches Esplugues, desguace Baix Llobregat"
        canonical={`${siteUrl}/desguace-esplugues`}
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#1a2332] to-[#2d3e50]">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
              Desguace en Esplugues de Llobregat
            </h1>
            <p className="text-xl text-white/90 leading-relaxed mb-8">
              Compramos tu coche en Esplugues al mejor precio. Recogida gratuita y pago inmediato
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20vender%20mi%20coche%20en%20Esplugues" 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-10 py-5 bg-[#25D366] text-white rounded-full font-bold text-lg hover:bg-[#1da851] transition-all shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-3"></i>
                Vender mi Coche Ahora
              </a>
              <a 
                href="tel:+34932932913" 
                className="inline-flex items-center justify-center px-10 py-5 bg-white text-[#1a2332] rounded-full font-bold text-lg hover:bg-gray-100 transition-all shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-3"></i>
                932 932 913
              </a>
            </div>
          </div>
        </section>

        {/* Zonas de Esplugues */}
        <section className="py-16 bg-[#f8f9fa]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-black text-[#1a2332] mb-8 text-center">
              Servicio en Todas las Zonas de Esplugues de Llobregat
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {[
                'Can Clota',
                'Can Vidalet',
                'La Plana',
                'Centre',
                'Ciudad Diagonal',
                'Finestrelles',
                'Can Güell',
                'Zona Universitaria',
                'Collblanc',
                'Zona Industrial',
                'Zona Residencial',
                'Zona Centro'
              ].map((zona, index) => (
                <div key={index} className="bg-white p-4 rounded-lg shadow-sm text-center">
                  <i className="ri-map-pin-line text-[#ff6b35] text-2xl mb-2"></i>
                  <p className="text-sm font-medium text-[#1a2332]">{zona}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Ventajas */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-black text-[#1a2332] mb-12 text-center">
              ¿Por Qué Elegirnos en Esplugues?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-[#f8f9fa] p-8 rounded-xl">
                <div className="w-16 h-16 bg-[#ff6b35] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-money-euro-circle-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#1a2332] mb-3 text-center">Mejor Precio</h3>
                <p className="text-gray-600 text-center leading-relaxed">
                  Ofrecemos las mejores valoraciones del mercado en Esplugues. Tasación gratuita y sin compromiso.
                </p>
              </div>

              <div className="bg-[#f8f9fa] p-8 rounded-xl">
                <div className="w-16 h-16 bg-[#ff6b35] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-truck-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#1a2332] mb-3 text-center">Recogida Gratis</h3>
                <p className="text-gray-600 text-center leading-relaxed">
                  Recogemos tu vehículo en cualquier punto de Esplugues sin coste adicional. Tú no te preocupes de nada.
                </p>
              </div>

              <div className="bg-[#f8f9fa] p-8 rounded-xl">
                <div className="w-16 h-16 bg-[#ff6b35] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#1a2332] mb-3 text-center">Pago Inmediato</h3>
                <p className="text-gray-600 text-center leading-relaxed">
                  Pago al momento de la recogida. Sin esperas ni trámites complicados. Dinero en efectivo o transferencia.
                </p>
              </div>

              <div className="bg-[#f8f9fa] p-8 rounded-xl">
                <div className="w-16 h-16 bg-[#ff6b35] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-file-list-3-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#1a2332] mb-3 text-center">Gestión Completa</h3>
                <p className="text-gray-600 text-center leading-relaxed">
                  Nos encargamos de todos los trámites administrativos y documentación. Servicio integral sin complicaciones.
                </p>
              </div>

              <div className="bg-[#f8f9fa] p-8 rounded-xl">
                <div className="w-16 h-16 bg-[#ff6b35] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#1a2332] mb-3 text-center">100% Legal</h3>
                <p className="text-gray-600 text-center leading-relaxed">
                  Desguace autorizado y certificado. Cumplimos toda la normativa vigente para tu tranquilidad.
                </p>
              </div>

              <div className="bg-[#f8f9fa] p-8 rounded-xl">
                <div className="w-16 h-16 bg-[#ff6b35] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-customer-service-2-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#1a2332] mb-3 text-center">Atención 24/7</h3>
                <p className="text-gray-600 text-center leading-relaxed">
                  Disponibles todos los días para atenderte. Respuesta rápida por WhatsApp, teléfono o email.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Tipos de Coches */}
        <section className="py-16 bg-[#f8f9fa]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-black text-[#1a2332] mb-12 text-center">
              Compramos Todo Tipo de Vehículos en Esplugues
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center">
                    <i className="ri-car-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-lg font-bold text-[#1a2332]">Coches Siniestrados</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Compramos vehículos declarados siniestro total por aseguradoras. Mejor precio que el valor residual.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center">
                    <i className="ri-tools-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-lg font-bold text-[#1a2332]">Coches Averiados</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Vehículos con averías mecánicas, eléctricas o de motor. No importa el estado, te hacemos una oferta.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center">
                    <i className="ri-file-warning-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-lg font-bold text-[#1a2332]">Coches Sin ITV</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Vehículos que no han pasado la ITV o llevan años sin revisión. Te ahorramos el coste de la inspección.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center">
                    <i className="ri-alert-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-lg font-bold text-[#1a2332]">Coches Accidentados</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Vehículos con daños por colisión que prefieres vender en lugar de reparar. Valoración justa.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center">
                    <i className="ri-time-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-lg font-bold text-[#1a2332]">Coches Antiguos</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Vehículos con muchos años que ya no son rentables de mantener. Piezas clásicas con valor.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center">
                    <i className="ri-checkbox-circle-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-lg font-bold text-[#1a2332]">Coches en Buen Estado</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  También compramos vehículos en perfecto estado si necesitas vender rápido. Precio competitivo.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-20 bg-gradient-to-br from-[#1a2332] to-[#2d3e50]">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-black text-white mb-6">
              ¿Tienes un Coche para Vender en Esplugues?
            </h2>
            <p className="text-xl text-white/90 mb-8">
              Contáctanos ahora y recibe una oferta en menos de 24 horas
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20vender%20mi%20coche%20en%20Esplugues" 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-10 py-5 bg-[#25D366] text-white rounded-full font-bold text-lg hover:bg-[#1da851] transition-all shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-3"></i>
                Contactar por WhatsApp
              </a>
              <a 
                href="tel:+34932932913" 
                className="inline-flex items-center justify-center px-10 py-5 bg-white text-[#1a2332] rounded-full font-bold text-lg hover:bg-gray-100 transition-all shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-3"></i>
                Llamar Ahora
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
